import type { ScrapingHeroAction } from './types';

export const SCRAPING_HERO_TAB_IDS = [
  'scrape',
  'search',
  'map',
  'crawl',
] as const satisfies readonly ScrapingHeroAction[];

export const LOADING_STEP_KEYS = [
  'gathering',
  'reading',
  'thinking',
  'detecting',
  'drafting',
  'preparing',
] as const;

export type LoadingStepKey = (typeof LOADING_STEP_KEYS)[number];

export const STEP_DELAY_MIN_MS = 200;
export const STEP_DELAY_MAX_MS = 2_000;
export const SUCCESS_HOLD_MS = 3_000;
export const TRIAL_TIMEOUT_MS = 35_000;
export function randomStepDelayMs() {
  return (
    STEP_DELAY_MIN_MS + Math.random() * (STEP_DELAY_MAX_MS - STEP_DELAY_MIN_MS)
  );
}

export const SCRAPING_HERO_SCRAPE_JOB_STARTED_EVENT =
  'scraping_hero_scrape_job_started';
export const SCRAPING_HERO_SCRAPE_SUCCEEDED_EVENT =
  'scraping_hero_scrape_succeeded';
export const SCRAPING_HERO_SCRAPE_FAILED_EVENT = 'scraping_hero_scrape_failed';

export const TYPEWRITER_URL_EXAMPLES = [
  'https://github.com',
  'https://chatgpt.com',
  'https://amazon.com',
  'https://zillow.com',
];

// used when search submits with an empty input (no typewriter on this tab)
export const SEARCH_DEMO_QUERY = 'laptop';
